/*
 * Filtros por etiqueta (AJAX) — Fase B.
 * Lee los checkboxes de filtro (agrupados por data-group), consulta la API de filtros
 * (proyecto Filters) con OR dentro de grupo y AND entre grupos, y pinta los resultados
 * en el grid de la colección sin recargar. Opt-in: solo se activa si existe el config.
 */
(function () {
  'use strict';

  // El snippet se renderiza en el sidebar (desktop) y en el drawer (móvil), así que este
  // script puede inyectarse dos veces. Usamos delegación global en document: basta una vez.
  if (window.__tagfilterAjaxInit) return;
  window.__tagfilterAjaxInit = true;

  var cfg = document.querySelector('[data-tagfilter-config]');
  if (!cfg) return;

  var API = (cfg.getAttribute('data-api') || '').replace(/\/$/, '');
  var COLLECTION = cfg.getAttribute('data-collection') || '';
  var PER_PAGE = parseInt(cfg.getAttribute('data-perpage') || '24', 10);
  var BASE_URL = cfg.getAttribute('data-base-url') || '';
  var GRID_CLASSES = cfg.getAttribute('data-grid-classes') || '';
  var SHOW_INVENTORY = (cfg.getAttribute('data-show-inventory') || 'true') !== 'false';
  var LOW_STOCK = parseInt(cfg.getAttribute('data-low-stock') || '0', 10) || 0;
  if (!API || !COLLECTION) return;

  var results = document.querySelector('[data-tagfilter-results]');
  if (!results) return;
  var pagination = document.querySelector('[data-tagfilter-pagination]');

  var state = { page: 1, sort: cfg.getAttribute('data-sort') || 'manual' };
  var debounceTimer = null;
  var hasRenderedAjax = false; // ¿ya hemos sustituido el grid nativo por resultados filtrados?

  /* Etiquetas reales de un checkbox: data-tags (fusión de sinónimos: varias) o data-tag (una). */
  function cbTags(cb) {
    var multi = cb.getAttribute('data-tags');
    if (multi) return multi.split('~~').filter(function (x) { return x; });
    var one = cb.getAttribute('data-tag');
    return one ? [one] : [];
  }

  /* Recoge las selecciones agrupadas: { grupo: [tag, tag] } -> [[..],[..]] */
  function collectFilters() {
    var groups = {};
    document.querySelectorAll('[data-tagfilter-cb]:checked').forEach(function (cb) {
      var g = cb.getAttribute('data-group');
      if (!groups[g]) groups[g] = [];
      // una casilla puede aportar varias etiquetas (fusión); deduplicamos por grupo.
      cbTags(cb).forEach(function (t) { if (groups[g].indexOf(t) === -1) groups[g].push(t); });
    });
    return Object.keys(groups).map(function (g) { return groups[g]; });
  }

  // Formato del tema (currency_code_enabled=false): "€12,99"
  function money(v) {
    if (v == null || v === '') return '';
    var n = Number(v);
    if (isNaN(n)) return '';
    return '€' + n.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* Estrellas de respaldo: solo se usan si el script de Loox no llega a hidratar el widget. */
  function stars(rating, count) {
    if (!rating || rating <= 0) return '';
    var r = Math.round(rating);
    var html = '<span class="tf-rating" aria-label="' + rating + ' de 5">';
    for (var i = 1; i <= 5; i++) html += '<span class="tf-star' + (i <= r ? ' tf-star--on' : '') + '">★</span>';
    if (count) html += '<span class="tf-rating__count">(' + count + ')</span>';
    return html + '</span>';
  }

  /* --- Lectura de los "tags virtuales" que el índice mete en p.tags (__compare_price:, __savings:, etc.) --- */
  function tagVal(tags, prefix) {
    if (!tags) return null;
    for (var i = 0; i < tags.length; i++) {
      if (typeof tags[i] === 'string' && tags[i].indexOf(prefix) === 0) return tags[i].slice(prefix.length);
    }
    return null;
  }
  function tagHas(tags, value) { return !!tags && tags.indexOf(value) !== -1; }
  function tagBadges(tags) {
    var out = [];
    if (tags) tags.forEach(function (t) { if (typeof t === 'string' && t.indexOf('__badge:') === 0) out.push(t.slice(8)); });
    return out;
  }
  function looxId(gid) {
    var m = String(gid == null ? '' : gid).match(/(\d+)\s*$/);
    return m ? m[1] : '';
  }

  /* Valoración: el MISMO div de Loox que la card nativa (lo hidrata el script de Loox). */
  function ratingHtml(p) {
    return '<div class="loox-rating product-item__loox-rating" data-id="' + looxId(p.product_id) +
      '" data-rating="' + (p.loox_rating || 0) + '" data-raters="' + (p.loox_reviews || 0) + '"></div>';
  }

  /* Precio con precio de comparación (oferta), igual que el tema. */
  function priceHtml(p) {
    var cp = tagVal(p.tags, '__compare_price:');
    var cpNum = cp != null ? Number(cp) : null;
    var onSale = cpNum != null && p.price != null && cpNum > Number(p.price);
    // Cliente profesional: precio SIN IVA + CON IVA (misma lógica que pro-price.liquid).
    var pro = window.__proPricing;
    if (pro && pro.isPro && p.price != null) {
      return proPriceHtml(Number(p.price), onSale ? cpNum : null, pro);
    }
    var html = '<div class="product-item__price-list price-list">';
    if (onSale) {
      html += '<span class="price price--highlight"><span class="visually-hidden">Precio de oferta</span>' + money(p.price) + '</span>';
      html += '<span class="price price--compare"><span class="visually-hidden">Precio habitual</span>' + money(cpNum) + '</span>';
    } else {
      html += '<span class="price"><span class="visually-hidden">Precio</span>' + money(p.price) + '</span>';
    }
    return html + '</div>';
  }

  /* Precio dual profesional. Valores en euros (misma unidad que money()). neto = bruto / (1 + IVA/100). */
  function proPriceHtml(gross, compareGross, pro) {
    var vat = Number(pro.vatRate) || 0;
    var grossCents = Math.round(gross * 100);
    // Fórmula idéntica a pro-price.liquid: neto = round(bruto_cent * 100 / (100 + IVA)).
    var netCents = Math.round(grossCents * 100 / (100 + vat));
    var netStr = money(netCents / 100);
    var grossStr = money(gross);
    var compareStr = (compareGross != null && compareGross > gross) ? '<s class="pro-price__compare">' + money(compareGross) + '</s>' : '';
    var withoutLbl = escapeHtml(pro.labelWithout || 'sin IVA');
    var withLbl = escapeHtml(pro.labelWith || 'IVA incl.');
    return '<div class="product-item__price-list price-list">' +
      '<span class="pro-price pro-price--net-main">' +
        '<span class="pro-price__main price">' + netStr + ' <span class="pro-price__tax-label">' + withoutLbl + '</span></span>' +
        '<span class="pro-price__sub">' + grossStr + compareStr + ' <span class="pro-price__tax-label">' + withLbl + '</span></span>' +
      '</span>' +
    '</div>';
  }

  /* Etiquetas sobre la imagen: % de descuento + badges personalizados, igual que el tema. */
  function labelListHtml(p) {
    var labels = '';
    var savings = tagVal(p.tags, '__savings:');
    var cp = tagVal(p.tags, '__compare_price:');
    if (savings && cp) labels += '<span class="product-label product-label--on-sale">Ahorrar ' + escapeHtml(savings) + '</span>';
    tagBadges(p.tags).forEach(function (b) { labels += '<span class="product-label product-label--custom1">' + escapeHtml(b) + '</span>'; });
    return labels ? '<div class="product-item__label-list">' + labels + '</div>' : '';
  }

  /* Stock con cantidad, igual que el tema (no se muestra para inventario no gestionado). */
  function stockHtml(p) {
    if (!SHOW_INVENTORY) return '';
    if (tagHas(p.tags, '__untracked_inventory')) return '';
    if (p.available === false) return '<span class="product-item__inventory inventory">Agotado</span>';
    var inv = p.inventory;
    if (inv == null) return '';
    if (LOW_STOCK > 0 && inv <= LOW_STOCK) {
      return '<span class="product-item__inventory inventory inventory--low">' + (inv === 1 ? 'Solo queda 1 unidad' : 'Solo quedan ' + inv + ' unidades') + '</span>';
    }
    return '<span class="product-item__inventory inventory inventory--high">' + (inv === 1 ? 'Disponible, 1 unidad' : 'Disponibles, ' + inv + ' unidades') + '</span>';
  }

  function imageHtml(p) {
    if (!p.image) return '';
    return '<img class="product-item__primary-image" src="' + p.image + '" alt="' + escapeHtml(p.title || '') + '" loading="lazy">';
  }

  /* Card idéntica a la nativa (product-item.liquid): mismas clases -> mismo CSS del tema. */
  function card(p) {
    var url = BASE_URL ? (BASE_URL + '/products/' + p.handle) : ('/products/' + p.handle);
    return (
      '<div class="product-item product-item--vertical ' + GRID_CLASSES + '">' +
        labelListHtml(p) +
        '<a href="' + url + '" class="product-item__image-wrapper">' +
          '<div class="aspect-ratio" style="padding-bottom:100%">' + imageHtml(p) + '</div>' +
        '</a>' +
        '<div class="product-item__info"><div class="product-item__info-inner">' +
          '<a href="' + url + '" class="product-item__title text--strong link">' + escapeHtml(p.title || '') + '</a>' +
          ratingHtml(p) +
          priceHtml(p) +
          stockHtml(p) +
        '</div></div>' +
      '</div>'
    );
  }

  /* Pide a Loox que renderice las valoraciones inyectadas; si no, dibuja estrellas de respaldo. */
  function rehydrateRatings(scope) {
    var nodes = (scope || document).querySelectorAll('.loox-rating');
    if (!nodes.length) return;
    try { if (window.loox && loox.integration && typeof loox.integration.reInit === 'function') loox.integration.reInit(); } catch (e) {}
    try { if (window.loox && typeof loox.reInit === 'function') loox.reInit(); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('loox:rerender')); } catch (e) {}
    setTimeout(function () {
      nodes.forEach(function (el) {
        if (el.getAttribute('data-tf-fallback')) return;
        if (el.children.length || el.textContent.trim()) return; // Loox ya lo hidrató
        var r = parseFloat(el.getAttribute('data-rating')) || 0;
        var c = parseInt(el.getAttribute('data-raters'), 10) || 0;
        if (r > 0) { el.innerHTML = stars(r, c); el.setAttribute('data-tf-fallback', '1'); }
      });
    }, 800);
  }

  function renderPagination(page, pages) {
    if (!pagination) return;
    if (pages <= 1) { pagination.innerHTML = ''; return; }
    var html = '<nav class="pagination"><ul class="pagination__list" role="list">';
    for (var i = 1; i <= pages; i++) {
      html += '<li>' + (i === page
        ? '<span class="pagination__item pagination__item--current">' + i + '</span>'
        : '<button type="button" class="pagination__item" data-tagfilter-page="' + i + '">' + i + '</button>') + '</li>';
    }
    html += '</ul></nav>';
    pagination.innerHTML = html;
    pagination.querySelectorAll('[data-tagfilter-page]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.page = parseInt(b.getAttribute('data-tagfilter-page'), 10);
        run();
        results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function setLoading(on) {
    results.style.opacity = on ? '0.45' : '';
    results.style.pointerEvents = on ? 'none' : '';
  }

  function collectPrice() {
    var minEl = document.querySelector('[data-tagfilter-price-min]');
    var maxEl = document.querySelector('[data-tagfilter-price-max]');
    return { min: minEl && minEl.value ? minEl.value : '', max: maxEl && maxEl.value ? maxEl.value : '' };
  }

  // ¿Hay algún filtro de rango con texto escrito? Cuenta como filtro activo aunque (de momento)
  // no marque ningún valor — así no se recarga la página mientras se escribe.
  function hasActiveRange() {
    var active = false;
    document.querySelectorAll('[data-tagfilter-range]').forEach(function (box) {
      var mn = box.querySelector('[data-range-min]');
      var mx = box.querySelector('[data-range-max]');
      if ((mn && mn.value.trim() !== '') || (mx && mx.value.trim() !== '')) active = true;
    });
    return active;
  }

  // Valoración seleccionada (Loox): "N estrellas o más", o '' si ninguna.
  function collectRating() {
    var el = document.querySelector('[data-tagfilter-rating]:checked');
    return el ? (el.getAttribute('data-rating-min') || '') : '';
  }

  function activeCount() {
    var n = document.querySelectorAll('[data-tagfilter-cb]:checked').length;
    var p = collectPrice();
    if (p.min !== '' || p.max !== '') n++;
    if (hasActiveRange()) n++;
    if (collectRating()) n++;
    return n;
  }

  function escapeHtml(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* Etiqueta visible de un checkbox de filtro (el valor, sin el prefijo de grupo). */
  function chipLabel(cb) {
    var wrap = cb.closest ? cb.closest('.tagfilters__value') : null;
    var label = wrap ? (wrap.getAttribute('data-value') || '') : '';
    if (!label && wrap) {
      var l = wrap.querySelector('.tagfilters__label');
      if (l) label = l.textContent;
    }
    if (!label) {
      var t = cb.getAttribute('data-tag') || '';
      label = t.split('_').pop().split(':').pop();
    }
    return (label || '').trim();
  }

  function chipHtml(tag, label) {
    return '<button type="button" class="tagfilters__chip" data-tagfilter-chip="' + escapeHtml(tag) +
      '" aria-label="Quitar filtro ' + escapeHtml(label) + '">' + escapeHtml(label) +
      '<span class="tagfilters__chip-x" aria-hidden="true">✕</span></button>';
  }

  function priceChipHtml(text) {
    return '<button type="button" class="tagfilters__chip" data-tagfilter-chip-price="1" aria-label="Quitar filtro de precio">' +
      escapeHtml(text) + '<span class="tagfilters__chip-x" aria-hidden="true">✕</span></button>';
  }

  /* Valores seleccionados (deduplicados por tag) dentro de un contenedor dado. */
  function selectedItems(root) {
    var seen = {}, items = [];
    // Los checkboxes de un filtro de rango (data-range-cb) no se muestran como chips: el rango
    // se ve en sus propios campos Desde/Hasta.
    (root || document).querySelectorAll('[data-tagfilter-cb]:checked:not([data-range-cb])').forEach(function (cb) {
      var t = cb.getAttribute('data-tag');
      if (seen[t]) return;
      seen[t] = true;
      items.push({ tag: t, label: chipLabel(cb) });
    });
    return items;
  }

  /* Chips de filtros activos:
     - Escritorio (sidebar): UNA barra consolidada con todos los chips.
     - Móvil (drawer #mobile-collection-filters): chips POR GRUPO, debajo del título de cada filtro. */
  function renderActiveChips() {
    document.querySelectorAll('[data-tagfilter-chip],[data-tagfilter-chip-price],[data-tagfilter-group-chips]')
      .forEach(function (c) { c.remove(); });

    var price = collectPrice();
    var hasPrice = price.min !== '' || price.max !== '';
    var priceText = 'Precio: ' + (price.min !== '' ? price.min : '0') + '–' + (price.max !== '' ? price.max : '∞') + ' €';

    // (A) Barra consolidada — solo fuera del drawer (sidebar de escritorio).
    document.querySelectorAll('.tagfilters__active').forEach(function (bar) {
      if (bar.closest('#mobile-collection-filters')) return;
      var clearBtn = bar.querySelector('[data-tagfilter-clear]');
      var html = selectedItems(document).map(function (it) { return chipHtml(it.tag, it.label); }).join('');
      if (hasPrice) html += priceChipHtml(priceText);
      if (clearBtn) clearBtn.insertAdjacentHTML('beforebegin', html);
      else bar.insertAdjacentHTML('afterbegin', html);
    });

    // (B) Chips por grupo dentro del drawer móvil (cada grupo muestra lo suyo).
    var drawer = document.getElementById('mobile-collection-filters');
    if (!drawer) return;
    drawer.querySelectorAll('.tagfilters__group').forEach(function (group) {
      var html = selectedItems(group).map(function (it) { return chipHtml(it.tag, it.label); }).join('');
      if (!html) return;
      var box = document.createElement('div');
      box.className = 'tagfilters__group-active';
      box.setAttribute('data-tagfilter-group-chips', '');
      box.innerHTML = html;
      var summary = group.querySelector('summary');
      if (summary) summary.insertAdjacentElement('afterend', box);
      else group.insertAdjacentElement('afterbegin', box);
    });
  }

  // "Limpiar" solo visible cuando hay filtros aplicados; refresca también los chips.
  function updateClearButton() {
    var show = activeCount() > 0;
    document.querySelectorAll('[data-tagfilter-clear]').forEach(function (b) { b.hidden = !show; });
    renderActiveChips();
  }

  function run() {
    var filters = collectFilters();
    var price = collectPrice();

    // Sin selección (ni etiquetas ni precio ni rango ni valoración) -> volver a la colección nativa
    var totalChecked = document.querySelectorAll('[data-tagfilter-cb]:checked').length;
    var hasPrice = price.min !== '' || price.max !== '';
    var activeRange = hasActiveRange();
    var rating = collectRating();
    if (totalChecked === 0 && !hasPrice && !activeRange && !rating) {
      // Se han deseleccionado todos los filtros: si estábamos filtrando, recargar la
      // colección sin filtros (vuelve el grid nativo). Si nunca filtramos, no hacer nada.
      if (hasRenderedAjax) window.location.href = collectionPath();
      return;
    }

    // Rango activo que no coincide con ningún valor -> devolver 0 productos (no "todos").
    var queryFilters = filters;
    if (filters.length === 0 && activeRange) queryFilters = [['__tagfilter_no_match__']];

    // Ocultar la paginación nativa (la del catálogo completo) mientras filtramos
    document.querySelectorAll('.pagination').forEach(function (el) {
      if (!pagination || !pagination.contains(el)) el.style.display = 'none';
    });

    hasRenderedAjax = true;
    setLoading(true);
    var url = API + '/api/filtros/query?collection=' + encodeURIComponent(COLLECTION) +
      '&filters=' + encodeURIComponent(JSON.stringify(queryFilters)) +
      '&sort=' + encodeURIComponent(rating ? 'rating-desc' : state.sort) +
      '&page=' + state.page + '&limit=' + PER_PAGE +
      (price.min !== '' ? '&price_min=' + encodeURIComponent(price.min) : '') +
      (price.max !== '' ? '&price_max=' + encodeURIComponent(price.max) : '') +
      (rating ? '&rating_min=' + encodeURIComponent(rating) : '');

    fetch(url)
      .then(function (r) { if (!r.ok) throw new Error('API ' + r.status); return r.json(); })
      .then(function (data) {
        if (!data.products || data.products.length === 0) {
          results.innerHTML = '<p class="collection__empty-text" style="padding:40px 0;text-align:center">No hay productos con estos filtros.</p>';
        } else {
          results.innerHTML = data.products.map(card).join('');
        }
        renderPagination(data.page || 1, data.pages || 1);
        syncUrl(filters);
        updateClearButton();
        rehydrateRatings(results);
      })
      .catch(function (e) {
        console.error('[tagfilter]', e);
        results.innerHTML = '<p style="padding:40px 0;text-align:center">No se pudieron cargar los filtros.</p>';
      })
      .finally(function () { setLoading(false); });
  }

  function collectionPath() {
    // /collections/<handle>
    var m = window.location.pathname.match(/\/collections\/[^/]+/);
    return m ? m[0] : window.location.pathname;
  }
  function BASE_URL_PATH() { return collectionPath(); }

  /* Refleja la selección en la URL (?tf=base64) para compartir/atrás, sin recargar. */
  function syncUrl(filters) {
    try {
      var params = new URLSearchParams(window.location.search);
      if (filters.length) params.set('tf', btoa(unescape(encodeURIComponent(JSON.stringify(filters)))));
      else params.delete('tf');
      var qs = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (qs ? '?' + qs : ''));
    } catch (e) {}
  }

  /* Restaura selección desde la URL al cargar */
  function restoreFromUrl() {
    try {
      var tf = new URLSearchParams(window.location.search).get('tf');
      if (!tf) return false;
      var groups = JSON.parse(decodeURIComponent(escape(atob(tf))));
      var wanted = {};
      groups.forEach(function (g) { g.forEach(function (t) { wanted[t] = true; }); });
      document.querySelectorAll('[data-tagfilter-cb]').forEach(function (cb) {
        var tags = cbTags(cb);
        for (var i = 0; i < tags.length; i++) { if (wanted[tags[i]]) { cb.checked = true; break; } }
      });
      return Object.keys(wanted).length > 0;
    } catch (e) { return false; }
  }

  function onChange() {
    state.page = 1;
    updateClearButton();
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(run, 220);
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-tagfilter-cb]')) onChange();
  });

  // Valoración: selección única (tipo radio). Deja marcada solo la pulsada, en todas las instancias.
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches || !e.target.matches('[data-tagfilter-rating]')) return;
    var val = e.target.getAttribute('data-rating-min');
    var on = e.target.checked;
    document.querySelectorAll('[data-tagfilter-rating]').forEach(function (r) {
      r.checked = on && r.getAttribute('data-rating-min') === val;
    });
    onChange();
  });

  // Precio: filtrar mientras se escribe (con debounce)
  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-tagfilter-price-min],[data-tagfilter-price-max]')) onChange();
  });

  // ── Filtro por RANGO numérico (Desde/Hasta sobre valores de etiqueta) ──────────
  // Marca internamente los checkboxes (ocultos) del grupo cuyo número cae en el rango y
  // deja que el motor consulte por esas etiquetas (OR dentro del grupo). Sin cambios en la API.
  function rangeNum(v) { var n = parseFloat(String(v == null ? '' : v).replace(',', '.')); return isNaN(n) ? null : n; }
  function rangeEsc(s) { return String(s == null ? '' : s).replace(/"/g, '\\"'); }
  function applyRange(box) {
    var group = box.getAttribute('data-group');
    var minEl = box.querySelector('[data-range-min]');
    var maxEl = box.querySelector('[data-range-max]');
    var minRaw = ((minEl && minEl.value) || '').trim();
    var maxRaw = ((maxEl && maxEl.value) || '').trim();
    var none = (minRaw === '' && maxRaw === '');
    var min = parseFloat(minRaw); if (isNaN(min)) min = -Infinity;
    var max = parseFloat(maxRaw); if (isNaN(max)) max = Infinity;
    document.querySelectorAll('[data-range-cb][data-group="' + rangeEsc(group) + '"]').forEach(function (cb) {
      if (none) { cb.checked = false; return; }
      var n = rangeNum(cb.getAttribute('data-value'));
      cb.checked = (n !== null && n >= min && n <= max);
    });
    // Espeja los campos en la otra instancia del grupo (sidebar <-> drawer).
    document.querySelectorAll('[data-tagfilter-range][data-group="' + rangeEsc(group) + '"]').forEach(function (b) {
      if (b === box) return;
      var m1 = b.querySelector('[data-range-min]'); if (m1) m1.value = minEl ? minEl.value : '';
      var m2 = b.querySelector('[data-range-max]'); if (m2) m2.value = maxEl ? maxEl.value : '';
    });
    onChange();
  }
  document.addEventListener('input', function (e) {
    if (!e.target.closest) return;
    var box = e.target.closest('[data-tagfilter-range]');
    if (box && e.target.matches('[data-range-min],[data-range-max]')) applyRange(box);
  });
  // Inicializa cada filtro de rango: unidad + placeholders (mín/máx disponibles) + restaura desde la URL.
  function initRanges() {
    document.querySelectorAll('[data-tagfilter-range]').forEach(function (box) {
      var group = box.getAttribute('data-group');
      var cbs = document.querySelectorAll('[data-range-cb][data-group="' + rangeEsc(group) + '"]');
      var nums = [], checked = [], unit = '';
      cbs.forEach(function (cb) {
        var raw = cb.getAttribute('data-value') || '';
        if (!unit) unit = raw.replace(/[\d.,\s-]/g, '');
        var n = rangeNum(raw);
        if (n !== null) { nums.push(n); if (cb.checked) checked.push(n); }
      });
      if (!nums.length) return;
      var lo = Math.min.apply(null, nums), hi = Math.max.apply(null, nums);
      var minEl = box.querySelector('[data-range-min]'), maxEl = box.querySelector('[data-range-max]');
      if (minEl) minEl.placeholder = 'Desde ' + lo;
      if (maxEl) maxEl.placeholder = 'Hasta ' + hi;
      var u = box.querySelector('[data-range-unit]'); if (u) u.textContent = unit;
      if (checked.length) {
        if (minEl) minEl.value = Math.min.apply(null, checked);
        if (maxEl) maxEl.value = Math.max.apply(null, checked);
      }
    });
  }

  // "Limpiar" (botón con data-tagfilter-clear)
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-tagfilter-clear]');
    if (el) { e.preventDefault(); window.location.href = collectionPath(); }
  });

  // Quitar un filtro concreto desde su chip (✕)
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var chip = e.target.closest('[data-tagfilter-chip]');
    if (chip) {
      e.preventDefault();
      var tag = chip.getAttribute('data-tagfilter-chip');
      document.querySelectorAll('[data-tagfilter-cb]').forEach(function (cb) {
        if (cb.getAttribute('data-tag') === tag) cb.checked = false;
      });
      onChange();
      return;
    }
    var pchip = e.target.closest('[data-tagfilter-chip-price]');
    if (pchip) {
      e.preventDefault();
      document.querySelectorAll('[data-tagfilter-price-min],[data-tagfilter-price-max]').forEach(function (i) { i.value = ''; });
      onChange();
    }
  });

  // Al cargar: si hay selección en la URL, aplicarla
  if (restoreFromUrl()) run();
  initRanges();
  updateClearButton();
})();
